
import { AnalyticsCore } from './core';
import { EventCategories } from './constants';
import { AuthEvents } from './authEvents';

/**
 * Events related to prompt interactions
 */
export class PromptEvents extends AuthEvents {
  /**
   * Track when a prompt is viewed
   */
  trackPromptView(promptId: string, promptTitle: string, categoryId?: string) {
    this.trackEvent({
      category: EventCategories.PROMPT,
      action: 'view',
      label: promptTitle,
      dimensions: {
        prompt_id: promptId,
        prompt_title: promptTitle,
        category_id: categoryId || 'undefined'
      }
    });
  }

  /**
   * Track when a prompt is copied
   */
  trackPromptCopy(promptId: string, promptTitle: string, categoryId?: string) {
    this.trackEvent({
      category: EventCategories.PROMPT,
      action: 'copy',
      label: promptTitle,
      dimensions: {
        prompt_id: promptId,
        prompt_title: promptTitle,
        category_id: categoryId || 'undefined'
      }
    });
    
    // Also track as a conversion
    this.trackEvent({
      category: EventCategories.CONVERSION,
      action: 'prompt_copied',
      label: promptTitle,
      dimensions: {
        prompt_id: promptId
      }
    });
  }

  /**
   * Track prompt likes
   */
  trackPromptLike(promptId: string, promptTitle: string) {
    this.trackEvent({
      category: EventCategories.PROMPT,
      action: 'like',
      label: promptTitle,
      dimensions: {
        prompt_id: promptId,
        prompt_title: promptTitle
      }
    });
  }

  /**
   * Track prompt saves
   */
  trackPromptSave(promptId: string, promptTitle: string, collectionId?: string) {
    this.trackEvent({
      category: EventCategories.PROMPT,
      action: 'save',
      label: promptTitle,
      dimensions: {
        prompt_id: promptId,
        prompt_title: promptTitle,
        collection_id: collectionId || 'default'
      }
    });
  }
  
  /**
   * Track prompt usage (for any interaction)
   */
  trackPromptUse(promptId: string, actionType: string, promptTitle: string) {
    this.trackEvent({
      category: EventCategories.PROMPT,
      action: `use_${actionType}`,
      label: promptTitle,
      dimensions: {
        prompt_id: promptId,
        prompt_title: promptTitle,
        action_type: actionType
      }
    });
  }
  
  /**
   * Track prompt creation
   */
  trackPromptCreate(promptId: string, promptTitle: string, categoryId: string) {
    this.trackEvent({
      category: EventCategories.PROMPT,
      action: 'create',
      label: promptTitle,
      dimensions: {
        prompt_id: promptId,
        prompt_title: promptTitle,
        category_id: categoryId
      }
    });
    
    // Also track as a conversion
    this.trackEvent({
      category: EventCategories.CONVERSION,
      action: 'prompt_created',
      label: promptTitle
    });
  }

  /**
   * Track when a prompt is shared
   */
  trackPromptShare(promptId: string, platform: string, promptTitle: string) {
    this.trackEvent({
      category: EventCategories.PROMPT,
      action: 'share',
      label: promptTitle,
      dimensions: {
        prompt_id: promptId,
        prompt_title: promptTitle,
        platform: platform
      }
    });
  }
}
